module.exports = __webpack_public_path__ + "static/media/Kopenhagen_1-2.650c34cc.jpg";